import React from 'react';

import { Header } from './Header';
import { Footer } from './Footer';
import { FirstPage } from './FirstPage';
import { useViewModel } from './useViewModel';
import { UvInsertsFlow } from '../../uv-inserts/UvInsertsFlow';

import styles from './modal.module.css';
import { usePage } from '../../context/PageContext';

/**
 * GiftWrapModal handles the product gift wrapping flow, including step navigation.
 *
 * When currentPage is 'firstPage', the standard FirstPage + Header + Footer shell is shown.
 * For any subsequent page (addPersonalTouch and beyond), the UV inserts sub-flow takes over.
 * UvInsertsFlow mounts its own TanStack memory router, overrides PageContext for its
 * internal Header/Footer, and bridges back to the outer PageContext only for FINISHED and
 * returning to firstPage. This means Header and Footer are NOT rendered here in UV inserts
 * mode — UvInsertsFlow renders them inside its own PageContext.Provider override.
 *
 * @param {Object} props - Component props.
 * @param {boolean} props.isOpen - Whether the modal is open.
 * @param {function} props.onClose - Callback for closing the modal.
 * @returns {import('react').JSX.Element}
 */
export function GiftWrapModal({ isOpen, onClose }) {
  const { dialogModalRef, handleClose } = useViewModel({ isOpen, onClose });
  const { currentPage } = usePage();

  return (
    <dialog ref={dialogModalRef} className={styles['giftWrap__modal']}>
      {currentPage === 'firstPage' ? (
        <>
          <Header onClose={handleClose} />
          <div className={styles['giftWrap__modal-content']}>
            <FirstPage />
          </div>
          <Footer />
        </>
      ) : (
        // UV inserts sub-flow: owns Header, Outlet, and Footer internally.
        <UvInsertsFlow onClose={handleClose} />
      )}
    </dialog>
  );
}
